// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__10HRK","alert":"SettungsInbox_alert__1axEG"};